import { render, staticRenderFns } from "./CondominiumContactCard.vue?vue&type=template&id=34ebdbdb&scoped=true"
import script from "./CondominiumContactCard.vue?vue&type=script&lang=js"
export * from "./CondominiumContactCard.vue?vue&type=script&lang=js"
import style0 from "./CondominiumContactCard.vue?vue&type=style&index=0&id=34ebdbdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ebdbdb",
  null
  
)

export default component.exports